import React from 'react';
import classNames from 'classnames';

import { sanitizer } from 'utils/sanitizer';

interface IProps {
  title: string;
  className?: string;
}

const PageHeader: React.FC<IProps> = ({ title, className }) => {
  return (
    <div className={classNames('page-header-wrapper', className)}>
      <div className="content-wrapper">
        <h1 dangerouslySetInnerHTML={{ __html: sanitizer(title) }} />
      </div>
    </div>
  );
};

export default PageHeader;
